export default class Sport {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
